import React, { useState } from 'react';
import api from 'helpers/api';
import useGym from 'helpers/use_gym';
import notification from 'helpers/notification';
import plural from 'helpers/plural';
import Button from 'react/components/button';
import contactType from 'helpers/contact_type';
import { Contact } from 'react/types/contact';

type ArchiveContactModalProps = {
  cancel: () => void;
  submitModal: () => void;
  contact?: Contact;
  contacts?: Contact[];
};

const ArchiveContactModal = (props: ArchiveContactModalProps) => {
  const { cancel, submitModal, contact, contacts } = props;
  const gym = useGym();
  const [isLoading, setIsLoading] = useState(false);

  const isBulk = !!contacts;
  const contactsToArchive = isBulk ? contacts : [contact];
  const count = contactsToArchive.length;

  const deleteContact = (contactToDelete: Contact) => {
    const type = contactType(contactToDelete.type);
    const url = `/gyms/${gym.id}/${type}/${contactToDelete.id}`;
    return api.delete(url);
  };

  const submit = () => {
    setIsLoading(true);

    const promises = contactsToArchive.map((c) => deleteContact(c));

    Promise.all(promises).then(
      () => {
        if (isBulk) {
          notification.success(`${plural('contact', count, true)} successfully archived`);
        } else {
          notification.success(`${contact.name} successfully archived`);
        }
        submitModal();
      },
      () => {
        notification.error('Request could not be completed. Please try again');
        setIsLoading(false);
      },
    );
  };

  return (
    <>
      <div className="modal-body">
        {isBulk ? (
          <p>
            Are you sure you want to archive {count} selected {plural('contact', count)}?
          </p>
        ) : (
          <p>Are you sure you want to archive the contact {contact?.name}?</p>
        )}
      </div>
      <div className="modal-footer">
        <Button onClick={() => cancel()} disabled={isLoading}>
          Cancel
        </Button>
        <Button variant="success" onClick={() => submit()} disabled={isLoading}>
          Archive
        </Button>
      </div>
    </>
  );
};

export default ArchiveContactModal;
